import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { emailRegexp } from '@tablesready/common-ui';
import { AuthStatesEnum } from '../../constants';
import { AuthService } from '@tablesready/frontend-auth';
import { AlertsService, IAlertTypes } from '@tablesready/frontend-alerts-bar';
import {
  APP_VARIABLES_TOKEN,
  AppVariables,
  AppVariablesBrand,
} from '@tablesready/frontend-variables';

@Component({
  selector: 'tablesready-reset-password',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  @Output()
  onToggle = new EventEmitter<AuthStatesEnum>();

  form: UntypedFormGroup;
  submitting = false;
  authStates = AuthStatesEnum;
  domain: string;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly alertService: AlertsService,
    private readonly activatedRoute: ActivatedRoute,
    @Inject(APP_VARIABLES_TOKEN) public readonly appVariables: AppVariables,
  ) {
  }

  ngOnInit(): void {
    this.domain = AppVariablesBrand.TablesReady.toLowerCase();
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailRegexp)]],
    });
  }

  ngOnDestroy(): void {
    this.onToggle.complete();
  }

  createAccount(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { btn: 'login' },
      queryParamsHandling: 'merge',
    }).then(() => this.onToggle.emit(this.authStates.signup));
  }

  reset() {
    this.authService.passwordReset(this.form.value.email, this.domain)
      .pipe(
        map(() => {
          this.alertService.add({
            type: IAlertTypes.success,
            heading: 'Success: ',
            body: 'Your username and password has been emailed to you.',
          });
          this.onToggle.emit(this.authStates.login);
        }),
        catchError(error => {
          this.alertService.add({
            type: IAlertTypes.danger,
            heading: 'Error resetting password.',
            body: error,
          });

          return of();
        }),
        finalize(() => this.submitting = false),
      )
      .subscribe();
  }
}
